import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { miniGameService } from "../../services/miniGameService";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader"; // Thêm react-spinners
import "./manage-question.css"; // Thêm file CSS để tùy chỉnh giao diện

const StaffQuestionManager = () => {
  const [question, setQuestion] = useState({
    questionText: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    correctAnswer: "",
  });
  const [pendingQuestions, setPendingQuestions] = useState([]);
  const [expandedQuestionId, setExpandedQuestionId] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false); // Trạng thái loading
  const { userInfo } = useSelector((state) => state.user);

  useEffect(() => {
    fetchPendingQuestions();
  }, []);

  const fetchPendingQuestions = async () => {
    try {
      const response = await miniGameService.fetchPendingQuestions();
      setPendingQuestions(response.data);
    } catch (err) {
      toast.error("Không thể tải câu hỏi đang chờ duyệt.");
    }
  };

  const handleInputChange = (e) => {
    setQuestion({ ...question, [e.target.name]: e.target.value });
  };

  const createQuestion = async () => {
    if (!validateQuestion()) return;
    try {
      await miniGameService.createQuestions(question, userInfo.id);
      toast.success("Tạo câu hỏi thành công!");
      setQuestion({
        questionText: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        correctAnswer: "",
      });
    } catch (err) {
      toast.error("Lỗi khi tạo câu hỏi.");
    }
  };

  const generateQuestions = async () => {
    setIsGenerating(true); // Bật spinner
    try {
      await miniGameService.generateQuestions();
      toast.info("Đã tạo câu hỏi! Kiểm tra danh sách bên dưới.");
      await fetchPendingQuestions();
    } catch (err) {
      toast.error("Lỗi khi tạo câu hỏi bằng AI.");
    } finally {
      setIsGenerating(false); // Tắt spinner
    }
  };

  const approveQuestion = async (id) => {
    try {
      await miniGameService.approveQuestion(id, userInfo.id);
      toast.success("Duyệt câu hỏi thành công!");
      fetchPendingQuestions();
    } catch (err) {
      toast.error("Lỗi khi duyệt câu hỏi.");
    }
  };

  const discardQuestion = async (id) => {
    try {
      await miniGameService.discardQuestion(id);
      toast.success("Đã hủy câu hỏi.");
      fetchPendingQuestions();
    } catch (err) {
      toast.error("Lỗi khi hủy câu hỏi.");
    }
  };

  const validateQuestion = () => {
    const { questionText, optionA, optionB, optionC, optionD, correctAnswer } =
      question;
    if (
      !questionText ||
      !optionA ||
      !optionB ||
      !optionC ||
      !optionD ||
      !correctAnswer
    ) {
      toast.error("Vui lòng điền đầy đủ tất cả các trường.");
      return false;
    }
    if (!["A", "B", "C", "D"].includes(correctAnswer)) {
      toast.error("Vui lòng chọn đáp án đúng hợp lệ (A, B, C hoặc D).");
      return false;
    }
    return true;
  };

  const toggleQuestion = (id) => {
    setExpandedQuestionId(expandedQuestionId === id ? null : id);
  };

  return (
    <div className="container mx-auto p-6 max-w-4xl">
      <h2 className="text-3xl font-bold text-gray-800 mb-6">
        Quản lý câu hỏi đố vui
      </h2>

      {/* Manual Question Creation */}
      <div className="bg-white p-6 rounded-xl shadow-md mb-8">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">
          Tạo câu hỏi mới
        </h3>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Câu hỏi
            </label>
            <input
              type="text"
              name="questionText"
              placeholder="Nhập câu hỏi"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              value={question.questionText}
              onChange={handleInputChange}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Lựa chọn A
              </label>
              <input
                type="text"
                name="optionA"
                placeholder="Lựa chọn A"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                value={question.optionA}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Lựa chọn B
              </label>
              <input
                type="text"
                name="optionB"
                placeholder="Lựa chọn B"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                value={question.optionB}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Lựa chọn C
              </label>
              <input
                type="text"
                name="optionC"
                placeholder="Lựa chọn C"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                value={question.optionC}
                onChange={handleInputChange}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Lựa chọn D
              </label>
              <input
                type="text"
                name="optionD"
                placeholder="Lựa chọn D"
                className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
                value={question.optionD}
                onChange={handleInputChange}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">
              Đáp án đúng
            </label>
            <select
              name="correctAnswer"
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              value={question.correctAnswer}
              onChange={handleInputChange}
            >
              <option value="">Chọn đáp án đúng</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
            </select>
          </div>
        </div>
        <div className="mt-6 flex space-x-4">
          <button
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 active:bg-blue-800 transition duration-200"
            onClick={createQuestion}
          >
            Tạo câu hỏi
          </button>
          <button
            className="bg-green-600 text-white px-6 py-3 rounded-lg hover:bg-green-700 active:bg-green-800 transition duration-200 flex items-center"
            onClick={generateQuestions}
            disabled={isGenerating}
          >
            {isGenerating ? (
              <>
                <ClipLoader size={20} color="#ffffff" className="mr-2" />
                Đang tạo...
              </>
            ) : (
              "Tạo bằng AI"
            )}
          </button>
        </div>
      </div>

      {/* Pending Questions Review */}
      <div className="bg-white p-6 rounded-xl shadow-md">
        <h3 className="text-xl font-semibold text-gray-700 mb-4">
          Duyệt câu hỏi do AI tạo
        </h3>
        {pendingQuestions.length === 0 && (
          <p className="text-gray-500 italic">
            Không có câu hỏi nào đang chờ duyệt.
          </p>
        )}
        {pendingQuestions.map((q) => (
          <div
            key={q.id}
            className="border border-gray-200 rounded-lg mb-4 overflow-hidden"
          >
            <div
              className="bg-gray-50 p-4 flex justify-between items-center cursor-pointer hover:bg-gray-100 transition"
              onClick={() => toggleQuestion(q.id)}
            >
              <p className="font-medium text-gray-700 truncate">
                {q.questionText}
              </p>
              <svg
                className={`w-5 h-5 transform transition-transform ${
                  expandedQuestionId === q.id ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
            {expandedQuestionId === q.id && (
              <div className="p-4 bg-white">
                <p className="text-gray-600 mb-2">
                  <strong>Câu hỏi:</strong> {q.questionText}
                </p>
                <p className="text-gray-600 mb-2">
                  <strong>A:</strong> {q.optionA}
                </p>
                <p className="text-gray-600 mb-2">
                  <strong>B:</strong> {q.optionB}
                </p>
                <p className="text-gray-600 mb-2">
                  <strong>C:</strong> {q.optionC}
                </p>
                <p className="text-gray-600 mb-2">
                  <strong>D:</strong> {q.optionD}
                </p>
                <p className="text-gray-600 mb-2">
                  <strong>Đáp án đúng:</strong> {q.correctAnswer}
                </p>
                <p className="text-gray-500 text-sm mb-4">
                  <strong>Thời gian tạo:</strong>{" "}
                  {new Date(q.generatedAt).toLocaleString()}
                </p>
                <div className="flex space-x-4">
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 active:bg-green-800 transition duration-200"
                    onClick={() => approveQuestion(q.id)}
                  >
                    Duyệt
                  </button>
                  <button
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 active:bg-red-800 transition duration-200"
                    onClick={() => discardQuestion(q.id)}
                  >
                    Hủy
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StaffQuestionManager;
